import { Injectable } from '@angular/core';

export enum LoggerTypes { trace= 0, debug, info, log, warn, error, off }

@Injectable()
export class LoggerService {

  private currentLogType: any;
  constructor() {
    this.currentLogType = LoggerTypes.off;
  }

  setLogType(type: string) {
    switch (type) {
      case 'trace': this.currentLogType = LoggerTypes.trace; break;
      case 'debug': this.currentLogType = LoggerTypes.debug; break;
      case 'info': this.currentLogType = LoggerTypes.info; break;
      case 'log': this.currentLogType = LoggerTypes.log; break;
      case 'warn': this.currentLogType = LoggerTypes.warn; break;
      case 'error': this.currentLogType = LoggerTypes.error; break;
    }
  }
  trace(message: any) {
    if ( this.currentLogType === LoggerTypes.trace) {
      console.log('%cTrace', 'color:#6a6976;', message );
    }
  }

  debug(message: any) {
    if ( this.currentLogType <= LoggerTypes.debug) {
      console.log('%cDebug: ', 'color:#4990e2;', message );
    }
  }

  info(message: any) {
    if ( this.currentLogType <= LoggerTypes.info) {
      console.info('%cInfo: ' , 'color:#0000ff;', message );
    }
  }

  log(message: any) {
    if ( this.currentLogType <= LoggerTypes.log) {
      console.log('%cLog: ', 'color:#ffd667;', message );
    }
  }

  warn(message: any) {
    if ( this.currentLogType <= LoggerTypes.warn) {
      console.warn('%cWarning: ' , 'color:#ffd667;', message );
    }
  }

  error(message: any) {
    if ( this.currentLogType <= LoggerTypes.error) {
      console.error('%cError: ' , 'color:#ff0000;', message );
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/logger.service.ts